import React from 'react';

import * as helpers from './helpers';

const HeartIcon = ({
  color,
  width = 360.3,
  height = 360.3,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <path
      d="M328.5,52.3c-17.3-17.7-40.5-27.9-65.3-28.7c-19.9,0-50.3,7.6-83,43.2C146.5,29.3,113.9,23.6,97,23.6
      c-24.8,0.8-47.9,11-65.3,28.6c-23,21-33.4,51.9-27.7,82.4c10.5,75.9,98.8,169.4,171.5,205.8c1.4,0.7,3,1.1,4.6,1.1
      c1.6,0,3.2-0.4,4.6-1c72.7-36.5,161-129.9,171.5-205.7C362,104.1,351.5,73.3,328.5,52.3z M336,131.8c-4.4,31.5-24.5,69.3-56.7,106.5
      c-29.4,34-65.4,63.7-99.1,81.6c-33.6-18-69.6-47.7-99-81.7C49,201,28.9,163.1,24.4,131.5c-4.6-23.9,3.4-48,21.3-64.5l0.1-0.1
      C59.4,52.8,77.5,44.6,97,43.8c23.8,0,48.1,15,72.1,44.5l0.1,0.1c0.7,1.1,5,7,10.9,7.1h0.1c5.9,0,10-6,10.6-7
      c29.8-38.4,58.1-44.1,72.3-44.1c19.6,0.8,37.8,9,51.3,23.2l0.1,0.1C332.4,84,340.4,108,336,131.8z"
    />
  </svg>
);

export default HeartIcon;
